<template>
  <div>
    <MyHeader :bg="bgUrl" :name="$isCN() ? '主营业务' : 'Business'" :nameSecond="$isCN() ? 'Business' : ''" />
    <div :id="$i18Id($t('zdyw').title)"></div>
    <div class="page-content items-center mt-90">
      <SectionTitle :title="$t('zdyw').title" titleEN="Key Businesses" />
      <www-picture key="2" :img="$t('zdyw')['m']" w="686" h="440" class="img1-m" v-if="isMobile" :noCompress="true" />
      <www-picture key="1" :img="$t('zdyw')['pc']" w="1200" h="601" class="img1" v-else-if="!$isCN()" :noCompress="true" />
      <www-picture key="33" :img="$t('zdyw')['pc']" w="1200" h="579" class="img1-cn" v-else :noCompress="true" />
      <div :id="$i18Id($t('cpjz').title)" class="anchor_trans"></div>
      <SectionTitle :title="$t('cpjz').title" titleEN="Service Offerings" />
      <template v-if="isMobile">
        <www-picture key="3" :img="$t('cpjz')['m'][0]" w="686" h="568" class="img2-m" :noCompress="true" />
        <www-picture key="4" :img="$t('cpjz')['m'][1]" w="686" h="574" class="img2-m" :noCompress="true" />
      </template>
      <www-picture :img="$t('cpjz')['pc']" w="1380" h="712" class="img2" v-else :noCompress="true" />
      <!-- <Productions v-else /> -->
    </div>
    <MyFooter />
  </div>
</template>

<script>
import MyHeader from "../../../../components/MyHeader.vue";
import MyFooter from "../../../../components/MyFooter.vue";
import SectionTitle from "../../../../components/SectionTitle.vue";
// import Productions from "../../../../components/Productions.vue";
// import productsData from "../../../../data/products";

export default {
  computed: {
    // productsData() {
    // return productsData;
    // },
    bgUrl() {
      return this.$store.state.isMobileSite
        ? "//img.souche.com/glrl9xy4rsouj65yk82ajynr1vai5ws9.png"
        : "//img.souche.com/4y9128n50v0s918uv3v1luibrddzspqo.png";
    },
    isMobile() {
      return this.$store.state.isMobileSite;
    },
  },
  components: {
    MyHeader,
    MyFooter,
    // Productions,
    SectionTitle,
  },
  i18n: {
    messages: {
      zh: {
        title: "主营业务",
        cpjz: {
          title: "服务矩阵",
          pc: "//img.souche.com/bolt/RdsMwGv2uzZFHfgjBDzdq/pc-c2%20(2)%20(1).png",
          m: [
            "//img.souche.com/bolt/Uqlgun7VdkSJeYwWt7dp5/Group%2017384%20(2).png",
            "//img.souche.com/bolt/QE6KTTZcZI8vb1jBWp5nJ/Group%2017385.png",
          ],
        },
        zdyw: {
          title: "重点业务",
          m: "//img.souche.com/bolt/UB4Hi98FCsTMyUPGZwzVu/%E9%87%8D%E7%82%B9%E4%B8%9A%E5%8A%A1%20%E4%B8%AD%E6%96%87.png",
          pc: "//img.souche.com/bolt/2TPfgQMWS1Hoow-drpNWc/pc-c1%20(1).png",
          // pc: "//img.souche.com/hp8xhybhaf9omgbnfue13benezrge1nq.png",
        },
      },
      en: {
        title: "BUSINESS",
        zdyw: {
          title: "Key Businesses",
          m: "//img.souche.com/bolt/hNC7E1U9WnFIJHbeLfauQ/%E9%87%8D%E7%82%B9%E4%B8%9A%E5%8A%A1%20%E8%8B%B1%E6%96%87.png",
          pc: "//img.souche.com/bolt/bH7DlPOwFZDLUheRwY458/pc-e1%20(1).png",
        },
        cpjz: {
          title: "Service Offerings",
          pc: "//img.souche.com/bolt/fNpaQBHUMRTepTYW00xoh/Group%2017370%20(1).png",
          m: [
            "//img.souche.com/bolt/eJAYNuAYIU8b_uDBhfkUa/%E8%A1%A84%20(2).png",
            "//img.souche.com/bolt/zCY3gPbD0T1q-cbXlY1i-/Group%2017386.png",
          ],
        },
      },
    },
  },
  head() {
    return {
      title: this.$t("title"),
    };
  },
};
</script>

<style lang="less" scoped>
.img-architecture {
  width: 1120px;
  height: 656px;
  margin-top: 60px;
}

.architecture {
  background: linear-gradient(238.88deg, #ffd9cb 0%, rgba(255, 217, 203, 0) 44.73%);
  background-repeat: no-repeat;
  background-size: cover;
  padding: 70px 0 100px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

// .chart-container {
//   display: flex;
//   flex-direction: row;
//   justify-content: center;
//   margin-top: 60px;
//   margin-bottom: 115px;

//   .item {
//     transition: transform 0.3s;

//     &:hover {
//       transform: translateY(-4px);
//     }
//     .title {
//       width: 270px;
//       height: 64px;
//       background: #ff571a;
//       box-shadow: 1px 5px 12px #f4f1f0;
//       border-radius: 4px;
//       font-style: normal;
//       font-weight: 500;
//       font-size: 24px;
//       line-height: 28px;
//       color: #ffffff;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       position: relative;
//       z-index: 2;
//     }

//     .title-r {
//       background: #264aff;
//     }

//     .img {
//       width: 560px;
//       height: 348px;
//       position: relative;
//       top: -20px;
//       left: 20px;
//       border-radius: 4px;
//       overflow: hidden;
//       box-sizing: border-box;
//     }
//     &:last-child {
//       margin-left: 60px;
//     }
//   }
// }
.img1 {
  margin-top: 40px;
  width: 1200px;
  height: 601px;
  overflow: hidden;
  margin-bottom: 110px;
}

.img1-cn {
  margin-top: 40px;
  width: 1200px;
  height: 579px;
  overflow: hidden;
  margin-bottom: 110px;
}

.img2 {
  margin-top: 40px;
  width: 1380px;
  height: 712px;
  margin-bottom: 140px;
  flex-shrink: 0;
}

.img1-m {
  flex-shrink: 0;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 48px;
}

.img2-m {
  flex-shrink: 0;
  width: 100%;
  margin-top: 20px;

  &:last-child {
    margin-bottom: 48px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/_lang/html/products/index.vue